<template>
  <div class="error-page">
    <div class="box">
      <h1>404 ERROR</h1>
      <h2>{{t('message.notFoundTitle')}}</h2>
      <p>{{t('message.notFoundDescription')}}</p>
      <c-btn01 :btnText="t('message.goToMain')" @click="utils.movePage('/')"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import utils from '@/common/Utils';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style lang="scss">
.error-page{
  display:flex;
  justify-content: center;
  align-items:center;
  height:90%;
  .box{
    text-align:center;
    h1{
      font-size:4rem;
      font-weight:600;
    }
    h2{
      margin-top:1rem;
      font-size:2.4rem;
      font-weight:300;
    }
    p{
      margin-top:3rem;
      font-weight:400;
    }
    .btn01{
      margin-top:3rem;
    }
  }
}
</style>
